module.exports = __webpack_public_path__ + "img/excel.79adce06.png";